import { getContext, setContext } from 'svelte';
export const createContext = (id) => {
    const contextId = Symbol(id);
    const provider = (value) => setContext(contextId, value);
    const consumer = () => getContext(contextId);
    return [provider, consumer, contextId];
};
